import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { GraphDotnetService, graphql, LibraryCacheEntry, LibraryCacheKey, Maybe } from 'app/shared/graph';

@Injectable({
    providedIn: 'root'
})
export class LibraryCacheService {
    private readonly graphDotnetService = inject(GraphDotnetService);

    getLibraryCacheKeys(prefix: string): Observable<LibraryCacheKey[]> {
        return this.graphDotnetService.query(graphql`query LoadLibraryCacheKeys($prefix: String!) {
            libraryCacheKeys(prefix: $prefix, count: 100) {
                key
                resource
                options {
                    value
                    name
                }
            }
        }`, {
            prefix: prefix
        }).pipe(map(q => q.libraryCacheKeys));
    }

    getLibraryCacheEntry(key: string): Observable<Maybe<LibraryCacheEntry> | undefined> {
        return this.graphDotnetService.query(graphql`query LoadLibraryCacheKeys($key: String!) {
            libraryCacheEntry(key: $key) {
                manifest {
                    files
                    versions {
                        key
                        createdUtc
                        fileIndices
                        createdUtc
                    }
                    states {
                        hash
                        flags
                    }
                }
                versions {
                    key
                    date
                    fileCount
                    files {
                        flags
                        hash
                        path
                    }
                }
            }
        }`, {
            key: key
        }).pipe(map(q => q.libraryCacheEntry));
    }

    deleteLibraryCacheEntry(key: string) {
        return this.graphDotnetService.mutate(graphql`mutation DeleteLibraryCacheEntry($key: String!) {
            deleteLibraryCacheEntry(key: $key)
        }`, { key: key });
    }
}
